
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FeedbackFormValues } from './schema';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { Checkbox } from '@/components/ui/checkbox';

interface FinalTabProps {
  form: UseFormReturn<FeedbackFormValues>;
}

const FinalTab = ({ form }: FinalTabProps) => {
  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="generalComment"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Commentaire général (optionnel)</FormLabel>
            <FormControl>
              <Textarea 
                placeholder="Ajoutez un commentaire général..."
                className="resize-none"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="finalMessage"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Message final (optionnel)</FormLabel>
            <FormControl>
              <Textarea 
                placeholder="Ajoutez un message d'encouragement ou de conclusion..."
                className="resize-none"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="certified"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-3 space-y-0 p-4 mt-2 bg-gray-50 rounded-md">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel className="font-medium">Certifier ce feedback</FormLabel>
              <p className="text-sm text-gray-500">
                En cochant cette case, vous certifiez que ce feedback est authentique et reflète votre évaluation professionnelle.
              </p>
            </div>
          </FormItem>
        )}
      />
    </div>
  );
};

export default FinalTab;
